module.exports = __webpack_public_path__ + "img/622.443ca57b.png";